import useAppData from "./useAppData";

export default function useShcs () {
    const { shcs } = useAppData();

    return shcs;
}